(function () {
  'use strict';

  angular
    .module('manageRoles')
    .config(config);

	  function config($stateProvider) {
		$stateProvider.state('manageRoles', {
			url : '/manage-roles',
			views : {
				'manageRoleView' : {
					templateUrl : 'manage-roles/views/manage-roles.tpl.html',
					controller : 'ManageRolesCtrl',
					controllerAs : 'manageRoles'
				}
			}
		});
	}
}());
